<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uoIjzxohfFhbPpHcxMkB2WF" lang="en-US"><span class="Basic_Bold"><a id="ud5TylBbhR7M8jqYs3kklhC"></a>PREFACE</span></p>
<p class="FIRSTPARAGRAPH" lang="en-US">Some changes happen gradually, almost imperceptibly. As waves lap against the shoreline, sands shift, shells and creatures from the sea wash ashore, then vanish as the waves recede. Swimmers jump the waves, surfers and boogie boarders catch the perfect ride into shore. The rhythmic ebb and flow mesmerize, inducing tranquility and harmony.</p>
<p class="Normal" lang="en-US">Yet some changes occur beneath the surface without our even noticing. A hidden riptide tugs at revelers frolicking in the ocean, suddenly and violently sweeping them off course or pulling them under.</p>
<p class="Normal" lang="en-US">Profound changes crept into the Berkshires. Some changes were transitory, making only minimal impact. On the other hand, some changes have remained indelibly etched into the fabric of our ways of life. Some scars were overtly presented, while others festered inside. The physical landscape of beautiful Western Massachusetts prevailed, yet the soul of Berkshire County hardened.</p>
<p class="Normal" lang="en-US">In January 1994, events involving a father and daughter changed the bucolic Berkshires forever. Memories of events run together, becoming fuzzy. Some folks are no longer alive to share their memories. Some do not feel at liberty to discuss these events. Some folks find the memories too painful to rehash. Some remember the impact more clearly than the facts. And for some folks, the memories are crystal clear. I have tried to piece together the most truthful understanding of the events.</p>
<p class="Normal" lang="en-US">What other changes happen without our awareness?</p>
<p class="Normal" lang="en-US">What other changes in our lives are hidden in plain sight?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?0d3be5fb